import React from "react";

import {
  categoryBadgeClass,
  categoryLabel,
  isSponsorJourneyPhaseCategory,
  journeyPhaseBadgeClass,
  journeyPhaseLabel,
} from "../../Utils/sponsorTipsConstants";

const BADGE_BASE =
  "inline-flex text-xs font-medium px-2 py-0.5 rounded-full leading-tight";

type CategoryBadgesProps = {
  category: string;
  isFm?: boolean;
  suppressParent?: boolean;
};

const CategoryBadges: React.FC<CategoryBadgesProps> = ({
  category,
  isFm = false,
  suppressParent = false,
}) => {
  const showPhase = isSponsorJourneyPhaseCategory(category) && !suppressParent;

  if (suppressParent && !isFm && !showPhase) return null;

  return (
    <div className="flex flex-wrap items-center gap-1.5">
      {isFm ? (
        <span
          className="shrink-0 text-sm leading-none text-gray-500"
          aria-hidden
        >
          ⚠
        </span>
      ) : null}
      {!suppressParent ? (
        <span className={`${BADGE_BASE} ${categoryBadgeClass(category, isFm)}`}>
          {categoryLabel(category)}
        </span>
      ) : null}
      {suppressParent && isFm ? (
        <span
          className={`${BADGE_BASE} bg-amber-50 text-amber-900 border border-amber-200`}
        >
          Failure mode
        </span>
      ) : null}
      {showPhase ? (
        <span className={`${BADGE_BASE} ${journeyPhaseBadgeClass()}`}>
          {journeyPhaseLabel(category)}
        </span>
      ) : null}
    </div>
  );
};

export default CategoryBadges;
